export const createBlobDownloader = (name: string) => (blob: Blob) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url;
  link.download = name
  document.body.appendChild(link);
  link.click();
  link.remove()
}